// extracted by mini-css-extract-plugin
export default {"root":"UB3sc","info":"qyWyk","checkboxMark":"erv0M","buttonsContainer":"F3Raj","button":"T86Bs","tablet":"CcaMf","mobile":"WuypU","smallMobile":"iahFB"};